import { useState } from 'react';

import { useAuth } from '@features/auth/hooks/useAuth';
import { useClubCardQuery, useTopPlayersQuery, useWinnersQuery } from '@features/club/api/hooks';
import { ClubParticipants } from '@features/club/ui/ClubParticipants/ClubParticipants';
import { ClockControlType } from '@features/shared/api/typings';
import { PlayerShieldQuickPeekWidget } from '@features/user/ui/PlayerShieldQuickPeek/PlayerShieldQuickPeekWidget';

type Props = {
  clubId: string;
};
export function ClubParticipantsWidget({ clubId }: Props) {
  const [clockControlType, setClockControlType] = useState<ClockControlType>('Blitz');
  const [query, setQuery] = useState('');
  const { data: club } = useClubCardQuery(clubId, { staleTime: Infinity });
  const {
    data: topPlayersData,
    fetchNextPage: onLoadMoreTopPlayers,
    hasNextPage: hasMoreTopPlayers,
    isPending: isTopPlayersLoading,
  } = useTopPlayersQuery(clubId, clockControlType, query);
  const {
    data: winners,
    fetchNextPage: onLoadMoreWinners,
    hasNextPage: hasMoreWinners,
    isPending: isWinnersLoading,
  } = useWinnersQuery(clubId);
  const { user } = useAuth();

  return (
    <ClubParticipants
      groupTitle={club?.groupTitle}
      topPlayers={topPlayersData?.topPlayers}
      onLoadMoreTopPlayers={onLoadMoreTopPlayers}
      hasMoreTopPlayers={hasMoreTopPlayers}
      isTopPlayersLoading={isTopPlayersLoading}
      self={topPlayersData?.self}
      winners={winners}
      onLoadMoreWinners={onLoadMoreWinners}
      hasMoreWinners={hasMoreWinners}
      isWinnersLoading={isWinnersLoading}
      currentUserId={user?.userId}
      clockControlType={clockControlType}
      onClockControlTypeChange={setClockControlType}
      query={query}
      onQueryChange={setQuery}
      renderShieldQuickPeek={(userId) => <PlayerShieldQuickPeekWidget userId={userId} />}
    />
  );
}
